export const mixpanelTrack = (event_name, properties, ...args) => {
  console.debug("TRACK mixpanel:", event_name, properties)
  mixpanel.track(event_name, properties, ...args)
}
